import React, { useState, useEffect } from 'react';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const TestimonialsCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // --- THIS IS THE CHANGE ---
  // The placeholder testimonials have been replaced with a curated selection of 5 real ones.
  // All image paths now point to your single client avatar.
  const testimonials = [
    {
      id: 1,
      name: "Krystal & Eric",
      event: "Wedding Celebration",
      rating: 5,
      image: "/assets/client-avatar.jpg",
      content: `The decor was more beautiful than I ever imagined. I honestly thought that kind of setup would have cost three times what we paid. The wedding looked like an event you'd expect from prominent people and celebrities. Thank you so much!`,
      date: "May 2024"
    },
    {
      id: 2,
      name: "World Resource Institute",
      event: "Restore Local Launch",
      rating: 5,
      image: "/assets/client-avatar.jpg",
      content: `We sincerely appreciate your hard work, creativity and dedication—everything, from the setup to the finishing touches—was seamless. Your contribution played a key role in making the event a success, and we truly couldn’t have done it without you.`,
      date: "March 2024"
    },
    {
      id: 3,
      name: "Faith",
      event: "Birthday Celebration",
      rating: 5,
      image: "/assets/client-avatar.jpg",
      content: `I just wanted to say thank you for the help you gave us... You went above and beyond, and your team was amazing. We truly appreciate it. Thank you again.`,
      date: "June 2024"
    },
    {
      id: 4,
      name: "Sylvia & Boaz",
      event: "Wedding Celebration",
      rating: 5,
      image: "/assets/client-avatar.jpg",
      content: `I loved the flowers at reception, the chandelier and lights. The decor made my day special. Thank you so much! You went above and beyond and for that I am truly grateful. Oh! And I loved my bouquet. Asante sana!`,
      date: "April 2024"
    },
    {
      id: 5,
      name: "Radio Africa Group",
      event: "Corporate Event",
      rating: 5,
      image: "/assets/client-avatar.jpg",
      content: `It was nice meeting you and working with you... Asante sana. We say thank you more.. you shall get value for the service you offered us. God bless you....`,
      date: "November 2023"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(timer);
  }, [testimonials.length]);

  const handlePrevious = () => {
    setCurrentIndex(currentIndex === 0 ? testimonials.length - 1 : currentIndex - 1);
  };

  const handleNext = () => {
    setCurrentIndex(currentIndex === testimonials.length - 1 ? 0 : currentIndex + 1);
  };

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Icon
        key={index}
        name="Star"
        size={16}
        className={index < rating ? "text-accent fill-current" : "text-muted-foreground"}
      />
    ));
  };

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-heading font-bold text-3xl lg:text-4xl text-foreground mb-4">
            What Our Clients Say
          </h2>
          <p className="font-body text-lg text-muted-foreground max-w-2xl mx-auto">
            Don't just take our word for it. Here's what our happy clients have to say about their experience with Luxe Allure.
          </p>
        </div>

        {/* Testimonials Carousel */}
        <div className="relative max-w-4xl mx-auto">
          <div className="bg-card elevation-card rounded-lg p-8 lg:p-12 relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute top-0 right-0 w-32 h-32 opacity-5">
              <Icon name="Quote" size={128} className="text-primary" />
            </div>

            {/* Testimonial Content */}
            <div className="relative z-10">
              {/* Rating */}
              <div className="flex items-center justify-center mb-6">
                <div className="flex items-center space-x-1">
                  {renderStars(testimonials[currentIndex].rating)}
                </div>
              </div>

              {/* Testimonial Text */}
              <blockquote className="text-center mb-8">
                <p className="font-body text-lg lg:text-xl text-foreground leading-relaxed italic">
                  "{testimonials[currentIndex].content}"
                </p>
              </blockquote>

              {/* Client Info */}
              <div className="flex flex-col items-center space-y-4">
                <div className="w-16 h-16 rounded-full overflow-hidden elevation-card">
                  <Image
                    src={testimonials[currentIndex].image}
                    alt={testimonials[currentIndex].name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="text-center">
                  <h4 className="font-heading font-bold text-lg text-foreground">
                    {testimonials[currentIndex].name}
                  </h4>
                  <p className="font-body text-muted-foreground">
                    {testimonials[currentIndex].event}
                  </p>
                  <p className="font-mono text-sm text-muted-foreground mt-1">
                    {testimonials[currentIndex].date}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Buttons */}
          <div className="absolute top-1/2 -translate-y-1/2 left-4 lg:-left-16">
            <Button
              variant="outline"
              size="icon"
              onClick={handlePrevious}
              className="w-12 h-12 rounded-full glassmorphic elevation-floating hover:elevation-card"
            >
              <Icon name="ChevronLeft" size={20} />
            </Button>
          </div>
          <div className="absolute top-1/2 -translate-y-1/2 right-4 lg:-right-16">
            <Button
              variant="outline"
              size="icon"
              onClick={handleNext}
              className="w-12 h-12 rounded-full glassmorphic elevation-floating hover:elevation-card"
            >
              <Icon name="ChevronRight" size={20} />
            </Button>
          </div>

          {/* Dots Indicator */}
          <div className="flex items-center justify-center space-x-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => handleDotClick(index)}
                className={`w-3 h-3 rounded-full transition-smooth ${
                  index === currentIndex
                    ? 'bg-primary' :'bg-muted-foreground hover:bg-primary/50'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>

        {/* View All Testimonials CTA */}
        <div className="text-center mt-12">
          <Button
            variant="outline"
            size="lg"
            onClick={() => window.location.href = '/testimonials'}
            className="px-8"
            iconName="MessageSquare"
            iconPosition="left"
          >
            View All Reviews
          </Button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsCarousel;